import { useId } from "react";

/** The credit mark: a gold coin with a four-point spark. One SVG so it looks the same on every device and in both themes. */
export function CreditIcon({ className = "size-4" }: { className?: string }) {
	const id = useId();
	return (
		<svg viewBox="0 0 24 24" className={`inline-block shrink-0 ${className}`} aria-hidden="true" data-testid="credit-icon">
			<defs>
				<linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
					<stop offset="0" stopColor="#FFD98A" />
					<stop offset="1" stopColor="#E39A1F" />
				</linearGradient>
			</defs>
			<circle cx="12" cy="12" r="11" fill={`url(#${id})`} />
			<circle cx="12" cy="12" r="8.6" fill="none" stroke="#7A4B06" strokeOpacity=".35" />
			<path d="M12 5.2c.5 3.7 1.6 5.1 6.8 6.8-5.2 1.7-6.3 3.1-6.8 6.8-.5-3.7-1.6-5.1-6.8-6.8C10.4 10.3 11.5 8.9 12 5.2Z" fill="#5A3A06" />
		</svg>
	);
}
